import type { PaymentData, PaymentMethod } from "@jti/fe-common";
import { PgsApi } from "@jti/rest-api";

import { TAGS } from "../common/tags";
import type { PaymentApiBuilder } from "../paymentApi.types";

type GetPaymentMethodsOptions = {
  skus?: string[];
};

export const getPaymentMethodsEndpoint = (builder: PaymentApiBuilder) => ({
  getPaymentMethods: builder.query<PaymentMethod[], GetPaymentMethodsOptions | void>({
    queryFn: async (options) => {
      const pgsApi = PgsApi.init();
      const response = await pgsApi.getPaymentMethods(options ?? undefined);
      return { data: response.data };
    },
    providesTags: [TAGS.PAYMENT_METHODS],
  }),
  getOrderPaymentMethod: builder.query<PaymentData, string>({
    queryFn: async (paymentToken) => {
      const pgsApi = PgsApi.init();
      const data = await pgsApi.getOrderPaymentMethod(paymentToken);
      return { data };
    },
    providesTags: (_result, _error, paymentToken) => [{ type: TAGS.PAYMENT_METHODS, id: paymentToken }],
  }),
});
